var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{style:({ color: ("#" + (_vm.$options.methods.getStatusColor(_vm.props))) })},[_vm._v("\n  "+_vm._s(_vm.$options.methods.getStatusLabel(_vm.props))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }